var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "filters" },
    [
      _c("filter-group", {
        attrs: {
          group: "bases",
          "i18n-key": "basis",
          "base-icon-style": "bev-icon"
        }
      }),
      _vm._v(" "),
      _c("filter-group", {
        attrs: {
          group: "times",
          "i18n-key": "time",
          "base-icon-style": "time-icon"
        }
      }),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.filterText,
            expression: "filterText"
          }
        ],
        attrs: { placeholder: _vm.i18n["free-text-filter"] },
        domProps: { value: _vm.filterText },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.filterText = $event.target.value
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-435edef2", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-435edef2","hasScoped":false,"optionsId":"1","buble":{"transforms":{}}}!./src/components/filters/filters.html
// module id = 144
// module chunks = 0